<template>
    <section class="comp_room_graph">
        <div class="comp_content">
            <div class="header" style=" margin-left: calc(1.25rem - 2px)">
                <DateInputHeader v-model="date"/>
            </div>
            <div
                ref="comp-body"
                class="wrp_comp_body"
                v-on:scroll="handleGlobalScroll($event)"
                @mousedown="armMouseMove"
                @mouseleave="clearMouseMove"
                @mouseup="clearMouseMove"
                @mousemove="mouseMove"
                @touchstart="armMouseMove"
                @touchmove="mouseMove"
                @touchend="clearMouseMove">
                <room-graph-table ref="graph" :reference-date="date"
                                  :onNewReservationDataChanged="data=>newReservationData=data"
                                  :horizontal-shift="xShift"
                                  :prevent-click="mouseMoved"/>
            </div>
            <div class="buttons" v-if="newReservationData">
                <a class="button new-button" v-on:click="createNewReservation">{{ $t('create_reservation') }}</a>
                <!--<a class="button small" style="border: 1px solid #ff0000; color: #ff0000">{{$t('blocation')}}</a>-->
                <a class="button small" style="border: 1px solid #5e544a; color: #5e544a"
                   v-on:click="cancelNewReservation">{{ $t('cancel') }}</a>
            </div>
        </div>
    </section>
</template>

<script>
import DateInputHeader from '../part/item/date_input_header';
import RoomGraphTable from '../part/ui/room-graph-table.vue';
import moment from 'moment/moment';

export default {
    name: 'room-graph',
    components: {RoomGraphTable, DateInputHeader},
    data() {
        return {
            date: new Date(),
            newReservationData: undefined,
            mouseMoved: false,
            mouseStart: undefined,
            xShift: 0
        }
    },
    watch: {},
    methods: {
        eventPos(e) {
            let pos;
            if (e.touches) {
                pos = [e.touches[0].clientX, e.touches[0].clientY];
            } else {
                pos = [e.clientX, e.clientY]
            }
            return pos
        },
        armMouseMove: function (e) {
            this.mouseStart = this.eventPos(e)
        },
        clearMouseMove: function (e) {
            this.mouseStart = undefined

            // Posunutí na konec event loopu
            setTimeout(() => this.mouseMoved = false, 0)
        },
        mouseMove: function (e) {
            if (this.mouseStart) {
                const pos = this.eventPos(e)
                const xDist = pos[0] - this.mouseStart[0]
                const dayShift = xDist > 0 ? Math.floor(xDist / 40) : Math.ceil(xDist / 40)/*TODO konstanta*/

                const xShiftRemainder = xDist - dayShift * 40

                if (dayShift) {
                    this.date = moment(this.date).add(-dayShift, 'day').toDate()
                }
                this.mouseStart[0] = pos[0] - xShiftRemainder

                this.xShift = xShiftRemainder

                if (xShiftRemainder > 20) {
                    this.mouseMoved = true
                }
            }
        },
        cancelNewReservation: function () {
            if (this.$refs.graph) {
                this.$refs.graph.cancelNewReservation()
            }
        },
        createNewReservation() {
            const {roomTypeId, roomId, from, to} = this.newReservationData
            window.location = `/#/bookings/new?from=${moment(from).startOf('day').format('yyyy-MM-DD')}&to=${moment(to).startOf('day').format('yyyy-MM-DD')}&room_type_id=${roomTypeId}&room_id=${roomId}`
        },
    },
    beforeDestroy() {
    }
}
</script>

<style lang="less" scoped>
@import "../../less/_core/global/font_sizes.less";
@import "../../less/_core/theme/core/colors.less";

.comp_room_graph {
    height: 100%;
    display: flex;

    .comp_content {
        height: 100%;
        width: 100%;
        max-width: 100%;
        display: flex;
        flex-direction: column;

        .header {
            display: flex;
            justify-content: center;

            .date-input-header {
                min-width: 0;
                width: 800px;
            }
        }

        .wrp_comp_body {
            flex: 1;
            min-height: 0;
            display: flex;
            margin-top: 16px;
        }
    }
}

.buttons {
    position: fixed;
    bottom: @r62;
    left: 0;
    right: 0;
    height: @r80;
    background-color: @color-bg;
    display: flex;
    gap: 5px;
    justify-content: center;
    padding: 13px;
}


@media screen and (max-width: 420px) {
    .button {
        padding: 14px 14px;

        &.small {
            padding: 14px 12px;
        }
    }
}

.button {
    cursor: pointer;
    padding: 14px 24px;
    border-radius: 12px;
    font-size: @r16;
    text-align: center;
    display: flex;
    align-items: center;
    transition: 0.3s background-color;

    &.new-button {
        background: #7F735C;
        color: #ffd200;
    }

    &:hover {
        background-color: #ffffff;

        &.new-button {
            background: #8f826a;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/templates/comp/room-graph.vue